import { SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { EXEMPTION_TYPE, EXONERATION_INSTITUTION } from "@utils/Constants";

const AddExemptionFormConfig = {
    submit: {
        label: "Agregar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_exoneracion",
                        "label": "Tipo Exoneracion",
                        "sizing": {
                            "sm": 12
                        },
                        "options": EXEMPTION_TYPE,
                        "validation": Yup.string().required("Este campo es requerido"),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "tipoDocumentoOtro",
                        "label": "Nombre Otro Tipo Exoneracion",
                        "sizing": {
                            "sm": 12
                        },
                        "visibleIf": {
                            "tipo_exoneracion": "99"
                        },
                        "validation": Yup.string().when("tipo_exoneracion", {
                            is: (tipo_exoneracion: unknown) => tipo_exoneracion == "99",
                            then: (s) => s.required("Este valor es requerido"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],

                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "institucion",
                        "label": "Nombre de la institución",
                        "sizing": {
                            "sm": 12
                        },
                        "options": EXONERATION_INSTITUTION,
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "nombreInstitucionOtros",
                        "label": "Nombre de la institución",
                        "sizing": {
                            "sm": 12
                        },
                        "visibleIf": {
                            "institucion": "99"
                        },
                        "validation": Yup.string().when("institucion", {
                            is: (institucion: unknown) => institucion == "99",
                            then: (s) => s.required("Este valor es requerido"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],
                [
                    {
                        "type": "date",
                        "name": "fecha_emision",
                        "label": "Fecha Emision",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required("Este campo es requerido"),
                    },
                    {
                        "type": "text",
                        "name": "numero_documento",
                        "label": "Número de exoneración o autorización",
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "articulo",
                        "label": "Articulo",
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "tipo_exoneracion": ["02", "03", "06", "07", "08"]
                        },
                        "validation": Yup.string().when("tipo_exoneracion", {
                            is: (tipo_exoneracion: unknown) => ["02", "03", "06", "07", "08"].includes(`${tipo_exoneracion}`),
                            then: (s) => s.required("Este valor es requerido"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                    {
                        "type": "text",
                        "name": "inciso",
                        "label": "Inciso",
                        "sizing": {
                            "sm": 6
                        },
                        "visibleIf": {
                            "tipo_exoneracion": ["02", "03", "06", "07", "08"]
                        },
                        "validation": Yup.string().when("tipo_exoneracion", {
                            is: (tipo_exoneracion: unknown) => ["02", "03", "06", "07", "08"].includes(`${tipo_exoneracion}`),
                            then: (s) => s.required("Este valor es requerido"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],
                [
                    {
                        "type": "text",
                        "suffix": "%",
                        "name": "porcentaje_compra",
                        "label": "Porcentaje Exoneracion",
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.number().typeError("El valor debe ser un número válido")
                            .required("Este campo es requerido"),
                    },
                    {
                        "type": "money",
                        "name": "monto_impuesto",
                        "label": "Monto Exoneracion",
                        "disabled": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().required("Este campo es requerido"),
                    }
                ],
            ]
        }
    ],
};


export default AddExemptionFormConfig;